import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ContentSpacing } from '@estee/elc-base-theme';
import { configConsumer, ServiceView } from '@estee/elc-service';
import { PRODUCT_CTA } from '@estee/elc-service-view-names';

import { classes } from '../../utils/Classes';
import { IProductImage, ISku, IVtoConfig, IVtoFeature } from '../../interfaces/IVto';

const { name: serviceName } = __serviceInfo__;

interface IVtoShadeCtaContainer {
    config: IVtoShadeCtaContainerConfig;
    selectedSku: ISku;
    largeImages?: IProductImage[];
    quantity?: number;
    selectedAutoReplenishOption?: number;
    isPairShadesTabActive: boolean;
    pairProductLargeImages: IProductImage[];
    selectedPairSku?: ISku;
    isSaveMatchEnabled?: boolean;
    isPerfectShadeEnabled?: boolean;
}

interface IVtoShadeCtaContainerConfig {
    vtoConfig: IVtoConfig;
    vtoFeature: IVtoFeature;
}

const Wrapper = styled.div`
    float: right;
    width: 48%;
    padding-right: ${ContentSpacing.space10};
    [dir='rtl'] & {
        float: left;
        padding-left: ${ContentSpacing.space10};
    }
`;

const hasPairProductCta = (config: IVtoConfig, isPairShadesTabActive: boolean) => {
    const vtoFoundationFeature = config.vtoFeature && config.vtoFeature.foundation;

    return !!(vtoFoundationFeature && vtoFoundationFeature.hasLipVto && isPairShadesTabActive);
};

export const VtoShadeCtaContainer = configConsumer(['vtoConfig', 'vtoFeature'])(
    observer(
        ({
            config,
            selectedSku,
            largeImages,
            selectedAutoReplenishOption,
            isPairShadesTabActive,
            pairProductLargeImages,
            selectedPairSku,
            isSaveMatchEnabled,
            isPerfectShadeEnabled
        }: IVtoShadeCtaContainer) => {
            const {
                parentProduct: { quantity }
            } = selectedSku;

            const showPairProductCta = hasPairProductCta(config, isPairShadesTabActive);

            const productCtaConfig = {
                ...config,
                selectedSku: showPairProductCta ? selectedPairSku : selectedSku,
                largeImages: showPairProductCta ? pairProductLargeImages : largeImages,
                quantity,
                selectedAutoReplenishOption
            };

            const ctaContainerClassNames = classes('vto-shade-grid-cta-container', {
                'elc-vto-shade-grid-cta-container-save-match':
                    !isPerfectShadeEnabled && isSaveMatchEnabled
            });

            return (
                <Wrapper className={ctaContainerClassNames}>
                    <ServiceView
                        name={PRODUCT_CTA}
                        config={productCtaConfig}
                        serviceName={serviceName}
                    />
                </Wrapper>
            );
        }
    )
);
